import { createSvgIcon } from '@mui/material/utils';

export const CheckboxCheckedIcon = createSvgIcon(
    <svg viewBox="0 0 20 20">
        <rect width="20" height="20" rx="4" stroke="none" />
        <polyline points="5.5,10.5 8.5,13 15,7" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>,
    "CheckboxChecked"
);

export default CheckboxCheckedIcon;
